import { gql } from '@apollo/client';
import { AdminTagInfo } from '../fragments';

export default gql`
  query adminTag($id: ID) {
    adminTag(id: $id) {
      ...AdminTagInfo
    }
  }
  ${AdminTagInfo}
`;
